import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent, reactive, onMounted, ref, onUnmounted, computed, nextTick } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import MortgageAmschedule from "./mortgage-amschedule.vue";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import { MORTGAGE_FREQUENCY } from "@Shared/@Types/application/application-enums";
import { toNumber } from "lodash";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { CALCULATOR_FORMS } from "@Broker/@Types/financial-tools/types";
import { defaultPrintAction } from "../store/financial-tools-actions";
import { calcPay, formatVal, isValidItem, roundReg } from "../utils";
import { showToast } from "@Shared/@Utils/constants";
const componentName = "MortgageAnalyzerContainer";
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    MortgageAmschedule,
    MortgageCalculatorsToolbar,
    ReportTabLayout
  }),
  props: {
    initData: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const inoudata = reactive({
      showAMsched: false,
      doHideAMsched: () => {
        inoudata.showAMsched = false;
      },
      frequency: MORTGAGE_FREQUENCY.MONTHLY,
      amortizPeriodMths: 0,
      totalLoanAmount: 0,
      interestRate: 0,
      mortgageTerm: 0,
      PandI: 0,
      revamortizPeriodMths: 0,
      mainyr: {
        1: 0,
        2: 0,
        3: 0,
        5: 0,
        10: 0
      },
      mortgageAmount: 0,
      intFact: 0,
      baseRevAm: 0,
      timeKind: 0,
      numPay2: 0,
      whatyear: 0
    });
    const isEmbedded = computed(() => {
      var _props$initData;
      return (_props$initData = props.initData) == null ? void 0 : _props$initData.mortgageType;
    });
    const handleClearSelection = () => {
      inoudata.frequency = MORTGAGE_FREQUENCY.MONTHLY;
      inoudata.showAMsched = false;
      inoudata.totalLoanAmount = 0;
      inoudata.interestRate = 0;
      inoudata.mortgageTerm = 0;
      inoudata.amortizPeriodMths = 300;
      inoudata.PandI = 0;
      inoudata.revamortizPeriodMths = 0;
      inoudata.mainyr = {
        1: 0,
        2: 0,
        3: 0,
        5: 0,
        10: 0
      };
    };
    const errorTotalLoanAmount = computed(() => {
      return isValidItem(inoudata.totalLoanAmount, 10000, 100000000, "financial-tools.mortgage_amount", "totalLoanAmount", null, formatMoneyValueLong);
    });
    const errorInterestRate = computed(() => {
      return isValidItem(inoudata.interestRate, 0, 100.0, "financial-tools.interest_rate", "interestRate", null, formatVal);
    });
    const errorAmortizPeriodMths = computed(() => {
      return isValidItem(inoudata.amortizPeriodMths, 1, 35 * 12, "financial-tools.amortization_period", "amortizPeriodMths", null, formatVal);
    });
    const errorMortgageTermMths = computed(() => {
      return isValidItem(inoudata.mortgageTerm, 1, 10 * 12, "financial-tools.mortgage_term", "mortgageTerm", null, formatVal);
    });
    const erMsgs = {
      errorMortgageTermMths,
      errorAmortizPeriodMths,
      errorTotalLoanAmount,
      errorInterestRate
    };
    function validInputs() {
      let isValid = true;
      for (const m of _Object$values(erMsgs)) {
        if (m.value !== "") {
          showToast("error", m.value);
          isValid = false;
        }
      }
      return isValid;
    }
    function computeResults(mode, whatyear) {
      var _freqNumMap$payFreq;
      if (!validInputs()) return false;
      const payFreq = inoudata.frequency;
      const freqNumMap = {
        [MORTGAGE_FREQUENCY.SEMI_MONTHLY]: 24,
        [MORTGAGE_FREQUENCY.BIWEEKLY]: 26,
        [MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY]: 26,
        [MORTGAGE_FREQUENCY.WEEKLY]: 52,
        [MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY]: 52
      };
      const freqNum = (_freqNumMap$payFreq = freqNumMap[payFreq]) != null ? _freqNumMap$payFreq : 12;
      const amort = toNumber(inoudata.amortizPeriodMths);
      const mortgage = toNumber(inoudata.totalLoanAmount);
      const intrate = toNumber(inoudata.interestRate) / 100;
      const payment = calcPay(mortgage, amort, intrate, 2, freqNum, payFreq);
      const intFact = Math.pow(1 + intrate / 2, 2 / freqNum) - 1;
      let principalBal = mortgage;
      let aYear = false;
      let annualCount = 1;
      let payAdd;
      for (payAdd = 1; principalBal > 0; payAdd++) {
        var _context;
        let checkLump = 0;
        if ((payAdd - 1) / Math.floor(freqNum) == annualCount) {
          aYear = true;
        }
        let interestPayment = roundReg(principalBal * intFact);
        let principalPayment = roundReg(payment - interestPayment);
        let checkBal = Math.min(principalPayment, principalBal);
        if (checkBal <= 0) {
          console.error("Check balance is less than or equal to 0");
          break;
        }
        principalBal = roundReg(principalBal - checkBal);
        if (aYear && 0 >= annualCount) {
          checkLump = principalBal;
          principalBal = roundReg(principalBal - checkLump);
        }
        if (principalBal < (interestPayment + principalPayment) / 2) {
          checkBal = checkBal + principalBal;
          principalBal = 0;
        }
        if (aYear) {
          annualCount++;
          aYear = false;
        }
        const yearN = payAdd / freqNum;
        if (_includesInstanceProperty(_context = [1, 2, 3, 5, 10]).call(_context, yearN)) inoudata.mainyr[yearN] = principalBal;
      }
      const totalYears = (payAdd - 1) / freqNum;
      inoudata.PandI = payment;
      inoudata.revamortizPeriodMths = Math.round(totalYears * 120) / 10;
      if (mode == 2) {
        let timeKind;
        if (whatyear == -1) {
          timeKind = 0;
        } else {
          whatyear = 0;
          timeKind = 1;
        }
        inoudata.intFact = intFact;
        inoudata.baseRevAm = inoudata.revamortizPeriodMths * freqNum / 12;
        inoudata.numPay2 = freqNum;
        inoudata.timeKind = timeKind;
        inoudata.whatyear = whatyear;
        inoudata.mortgageAmount = mortgage;
      }
      return true;
    }
    function payBal() {
      inoudata.showAMsched = false;
      return computeResults(1, -1);
    }
    function amortLink(whatyear) {
      inoudata.showAMsched = computeResults(2, whatyear);
    }
    const populateFromApplication = () => {
      const mortgageType = props.initData.mortgageType;
      if (!mortgageType) return false;
      const initData = props.initData;
      inoudata.totalLoanAmount = initData.totalLoanAmount || 0;
      inoudata.interestRate = initData.interestRate || 0.001;
      inoudata.amortizPeriodMths = initData.amortizPeriodMths || 0;
      inoudata.mortgageTerm = initData.mortgageTerm || 0;
      inoudata.frequency = initData.frequency;
      return true;
    };
    handleClearSelection();
    if (!populateFromApplication()) {
      const thisComponentCookieString = localStorage.getItem(componentName);
      if (thisComponentCookieString) {
        try {
          const thisComponentCookieData = JSON.parse(thisComponentCookieString);
          _Object$assign(inoudata, thisComponentCookieData);
        } catch (e) {
          console.error("Error parsing localStorage data for " + componentName + ":", e);
          localStorage.removeItem(componentName);
        }
      }
    }
    const isLoading = ref(false);
    const loadingSucceeded = ref(true);
    const runReport = async () => {
      isLoading.value = true;
      loadingSucceeded.value = true;
      amortLink(-1);
      await nextTick();
      const data = {
        paymentFrequency: inoudata.frequency,
        mortgageAmount: inoudata.totalLoanAmount,
        interestRate: inoudata.interestRate,
        PandI: inoudata.PandI,
        amortizationPeriod: inoudata.amortizPeriodMths,
        revisedAmortizationPeriod: inoudata.revamortizPeriodMths,
        amSchedule: amScheduleData.value
      };
      try {
        await defaultPrintAction({
          type: CALCULATOR_FORMS.MORTGAGE_ANALYZER,
          data
        });
      } catch (e) {
        loadingSucceeded.value = false;
        console.error(e);
      }
      isLoading.value = false;
    };
    const amScheduleData = ref(null);
    const generatedAmSchedule = data => {
      amScheduleData.value = data;
    };
    onMounted(() => {
      $("[name='mortgageTerm']").trigger("focus");
      if (isEmbedded.value) amortLink(-1);
    });
    onUnmounted(() => {
      inoudata.showAMsched = false;
      if (!isEmbedded.value) localStorage.setItem(componentName, _JSON$stringify(inoudata));
    });
    return {
      inoudata,
      mortgageFrequencyOptions: APPLICATION_FIELD_OPTIONS().mortgageFrequencyOptions,
      isLoading,
      loadingSucceeded,
      isEmbedded,
      roundReg,
      formatMoneyValueLong,
      formatVal,
      amortLink,
      payBal,
      handleClearSelection,
      generatedAmSchedule,
      runReport
    };
  }
});